import styledComponent from 'styled-components';

const StyledProfilePictureImage = styledComponent.img`
  max-width: 100%;
`;

export default StyledProfilePictureImage;
